{
  "defaultDate": "2026-05-14",
  "defaultTimeBlock": "10:00 - 10:15",
  "profiles": [{
    "pssCode": "PSS-001",
    "cards": { "linkedGenerators": 8, "totalCapacityMw": 1250, "totalLinks": 3, "totalPaths": 2, "totalContracts": 5 },
    "intraStateContracts": [
      { "id": "INTRA-MH-001", "flowArea": "Flow Area - 1", "start": "14/05/2026 10:00", "end": "14/05/2026 10:15", "direction": "Export", "capacityMw": 100, "atcMw": 85, "status": "Active" },
      { "id": "INTRA-MH-002", "flowArea": "Flow Area - 2", "start": "14/05/2026 10:00", "end": "14/05/2026 10:15", "direction": "Export", "capacityMw": 150, "atcMw": 120, "status": "Active" },
      { "id": "INTRA-MH-003", "flowArea": "Flow Area - 3", "start": "14/05/2026 10:00", "end": "14/05/2026 10:15", "direction": "Export", "capacityMw": 200, "atcMw": 160, "status": "Active" }
    ],
    "interStateContracts": [
      { "id": "INTER-MH-001", "flowArea": "Flow Area - 1", "start": "15/05/2026 00:00", "end": "15/05/2026 24:00", "direction": "Export", "capacityMw": 100, "atcMw": 90, "status": "Active" },
      { "id": "INTER-MH-002", "flowArea": "Flow Area - 2", "start": "15/05/2026 00:00", "end": "15/05/2026 24:00", "direction": "Export", "capacityMw": 200, "atcMw": 150, "status": "Active" },
      { "id": "INTER-MH-003", "flowArea": "Flow Area - 3", "start": "15/05/2026 00:00", "end": "15/05/2026 24:00", "direction": "Export", "capacityMw": 200, "atcMw": 180, "status": "Active" }
    ],
    "unitScheduleRows": [
      { "plant": "SolarGen Pvt Ltd", "unit": "SOLAR-01", "capacity": 200, "schedule": 120, "avc": 118, "actual": 115.2, "deviation": -4.8, "dsm": 0, "netPosition": 5, "status": "Within Limit" },
      { "plant": "WindGen Pvt Ltd", "unit": "WIND-01", "capacity": 150, "schedule": 80, "avc": 82, "actual": 85.3, "deviation": 5.3, "dsm": 0, "netPosition": 0, "status": "Within Limit" },
      { "plant": "SolarGen Pvt Ltd", "unit": "SOLAR-02", "capacity": 100, "schedule": 60, "avc": 58, "actual": 54.1, "deviation": -5.9, "dsm": 0, "netPosition": 2, "status": "Within Limit" },
      { "plant": "WindGen Pvt Ltd", "unit": "WIND-02", "capacity": 100, "schedule": 55, "avc": 57, "actual": 56.7, "deviation": 1.7, "dsm": 0, "netPosition": 0, "status": "Within Limit" }
    ],
    "revisionSummary": { "scheduleMw": 335, "actualMw": 331.3, "deviationMw": -3.7, "dsmUpMw": 0, "dsmDownMw": 7 },
    "revisionTrend": {
      "hourly": [
        {
          "time": "01:00",
          "schedule": 199,
          "actual": 175.3,
          "deviation": -23.7
        },
        {
          "time": "02:00",
          "schedule": 216,
          "actual": 186.8,
          "deviation": -29.2
        },
        {
          "time": "03:00",
          "schedule": 214,
          "actual": 176,
          "deviation": -38
        },
        {
          "time": "04:00",
          "schedule": 213,
          "actual": 166.2,
          "deviation": -46.8
        },
        {
          "time": "05:00",
          "schedule": 235,
          "actual": 182.7,
          "deviation": -52.3
        },
        {
          "time": "06:00",
          "schedule": 276,
          "actual": 223.7,
          "deviation": -52.3
        },
        {
          "time": "07:00",
          "schedule": 315,
          "actual": 268.2,
          "deviation": -46.8
        },
        {
          "time": "08:00",
          "schedule": 328,
          "actual": 290,
          "deviation": -38
        },
        {
          "time": "09:00",
          "schedule": 314,
          "actual": 284.8,
          "deviation": -29.2
        },
        {
          "time": "10:00",
          "schedule": 295,
          "actual": 271.3,
          "deviation": -23.7
        },
        {
          "time": "11:00",
          "schedule": 293,
          "actual": 269.3,
          "deviation": -23.7
        },
        {
          "time": "12:00",
          "schedule": 306,
          "actual": 276.8,
          "deviation": -29.2
        },
        {
          "time": "13:00",
          "schedule": 315,
          "actual": 277,
          "deviation": -38
        },
        {
          "time": "14:00",
          "schedule": 298,
          "actual": 251.2,
          "deviation": -46.8
        },
        {
          "time": "15:00",
          "schedule": 256,
          "actual": 203.7,
          "deviation": -52.3
        },
        {
          "time": "16:00",
          "schedule": 213,
          "actual": 160.7,
          "deviation": -52.3
        },
        {
          "time": "17:00",
          "schedule": 192,
          "actual": 145.2,
          "deviation": -46.8
        },
        {
          "time": "18:00",
          "schedule": 194,
          "actual": 156,
          "deviation": -38
        },
        {
          "time": "19:00",
          "schedule": 199,
          "actual": 169.8,
          "deviation": -29.2
        },
        {
          "time": "20:00",
          "schedule": 186,
          "actual": 162.3,
          "deviation": -23.7
        },
        {
          "time": "21:00",
          "schedule": 156,
          "actual": 132.3,
          "deviation": -23.7
        },
        {
          "time": "22:00",
          "schedule": 131,
          "actual": 101.8,
          "deviation": -29.2
        },
        {
          "time": "23:00",
          "schedule": 134,
          "actual": 96,
          "deviation": -38
        }
      ],
      "block": [
        {
          "block": 1,
          "time": "00:00",
          "schedule": 164,
          "actual": 144.3,
          "deviation": -19.7
        },
        {
          "block": 2,
          "time": "00:15",
          "schedule": 177,
          "actual": 157.4,
          "deviation": -19.6
        },
        {
          "block": 3,
          "time": "00:30",
          "schedule": 188,
          "actual": 167.5,
          "deviation": -20.5
        },
        {
          "block": 4,
          "time": "00:45",
          "schedule": 197,
          "actual": 174.7,
          "deviation": -22.3
        },
        {
          "block": 5,
          "time": "01:00",
          "schedule": 202,
          "actual": 177.4,
          "deviation": -24.6
        },
        {
          "block": 6,
          "time": "01:15",
          "schedule": 205,
          "actual": 177.9,
          "deviation": -27.1
        },
        {
          "block": 7,
          "time": "01:30",
          "schedule": 207,
          "actual": 177.5,
          "deviation": -29.5
        },
        {
          "block": 8,
          "time": "01:45",
          "schedule": 208,
          "actual": 176.6,
          "deviation": -31.4
        },
        {
          "block": 9,
          "time": "02:00",
          "schedule": 210,
          "actual": 177.2,
          "deviation": -32.8
        },
        {
          "block": 10,
          "time": "02:15",
          "schedule": 213,
          "actual": 179.3,
          "deviation": -33.7
        },
        {
          "block": 11,
          "time": "02:30",
          "schedule": 216,
          "actual": 181.7,
          "deviation": -34.3
        },
        {
          "block": 12,
          "time": "02:45",
          "schedule": 219,
          "actual": 184.2,
          "deviation": -34.8
        },
        {
          "block": 13,
          "time": "03:00",
          "schedule": 219,
          "actual": 183.5,
          "deviation": -35.5
        },
        {
          "block": 14,
          "time": "03:15",
          "schedule": 218,
          "actual": 181.3,
          "deviation": -36.7
        },
        {
          "block": 15,
          "time": "03:30",
          "schedule": 215,
          "actual": 176.4,
          "deviation": -38.6
        },
        {
          "block": 16,
          "time": "03:45",
          "schedule": 212,
          "actual": 170.8,
          "deviation": -41.2
        },
        {
          "block": 17,
          "time": "04:00",
          "schedule": 210,
          "actual": 165.7,
          "deviation": -44.3
        },
        {
          "block": 18,
          "time": "04:15",
          "schedule": 211,
          "actual": 163.3,
          "deviation": -47.7
        },
        {
          "block": 19,
          "time": "04:30",
          "schedule": 215,
          "actual": 164,
          "deviation": -51
        },
        {
          "block": 20,
          "time": "04:45",
          "schedule": 223,
          "actual": 169.1,
          "deviation": -53.9
        },
        {
          "block": 21,
          "time": "05:00",
          "schedule": 235,
          "actual": 179.1,
          "deviation": -55.9
        },
        {
          "block": 22,
          "time": "05:15",
          "schedule": 247,
          "actual": 190.2,
          "deviation": -56.8
        },
        {
          "block": 23,
          "time": "05:30",
          "schedule": 260,
          "actual": 203.4,
          "deviation": -56.6
        },
        {
          "block": 24,
          "time": "05:45",
          "schedule": 271,
          "actual": 215.7,
          "deviation": -55.3
        },
        {
          "block": 25,
          "time": "06:00",
          "schedule": 280,
          "actual": 226.8,
          "deviation": -53.2
        },
        {
          "block": 26,
          "time": "06:15",
          "schedule": 287,
          "actual": 236.5,
          "deviation": -50.5
        },
        {
          "block": 27,
          "time": "06:30",
          "schedule": 294,
          "actual": 246.4,
          "deviation": -47.6
        },
        {
          "block": 28,
          "time": "06:45",
          "schedule": 301,
          "actual": 256,
          "deviation": -45
        },
        {
          "block": 29,
          "time": "07:00",
          "schedule": 309,
          "actual": 266.2,
          "deviation": -42.8
        },
        {
          "block": 30,
          "time": "07:15",
          "schedule": 317,
          "actual": 275.8,
          "deviation": -41.2
        },
        {
          "block": 31,
          "time": "07:30",
          "schedule": 325,
          "actual": 284.9,
          "deviation": -40.1
        },
        {
          "block": 32,
          "time": "07:45",
          "schedule": 331,
          "actual": 291.5,
          "deviation": -39.5
        },
        {
          "block": 33,
          "time": "08:00",
          "schedule": 333,
          "actual": 294.1,
          "deviation": -38.9
        },
        {
          "block": 34,
          "time": "08:15",
          "schedule": 332,
          "actual": 293.9,
          "deviation": -38.1
        },
        {
          "block": 35,
          "time": "08:30",
          "schedule": 327,
          "actual": 290,
          "deviation": -37
        },
        {
          "block": 36,
          "time": "08:45",
          "schedule": 319,
          "actual": 283.8,
          "deviation": -35.2
        },
        {
          "block": 37,
          "time": "09:00",
          "schedule": 311,
          "actual": 278.2,
          "deviation": -32.8
        },
        {
          "block": 38,
          "time": "09:15",
          "schedule": 303,
          "actual": 273.1,
          "deviation": -29.9
        },
        {
          "block": 39,
          "time": "09:30",
          "schedule": 298,
          "actual": 271.2,
          "deviation": -26.8
        },
        {
          "block": 40,
          "time": "09:45",
          "schedule": 296,
          "actual": 272.3,
          "deviation": -23.7
        },
        {
          "block": 41,
          "time": "10:00",
          "schedule": 295,
          "actual": 273.8,
          "deviation": -21.2
        },
        {
          "block": 42,
          "time": "10:15",
          "schedule": 296,
          "actual": 276.4,
          "deviation": -19.6
        },
        {
          "block": 43,
          "time": "10:30",
          "schedule": 297,
          "actual": 278,
          "deviation": -19
        },
        {
          "block": 44,
          "time": "10:45",
          "schedule": 297,
          "actual": 277.4,
          "deviation": -19.6
        },
        {
          "block": 45,
          "time": "11:00",
          "schedule": 296,
          "actual": 274.8,
          "deviation": -21.2
        },
        {
          "block": 46,
          "time": "11:15",
          "schedule": 295,
          "actual": 271.3,
          "deviation": -23.7
        },
        {
          "block": 47,
          "time": "11:30",
          "schedule": 295,
          "actual": 268.2,
          "deviation": -26.8
        },
        {
          "block": 48,
          "time": "11:45",
          "schedule": 296,
          "actual": 266.1,
          "deviation": -29.9
        },
        {
          "block": 49,
          "time": "12:00",
          "schedule": 300,
          "actual": 267.2,
          "deviation": -32.8
        },
        {
          "block": 50,
          "time": "12:15",
          "schedule": 306,
          "actual": 270.8,
          "deviation": -35.2
        },
        {
          "block": 51,
          "time": "12:30",
          "schedule": 313,
          "actual": 276,
          "deviation": -37
        },
        {
          "block": 52,
          "time": "12:45",
          "schedule": 318,
          "actual": 279.9,
          "deviation": -38.1
        },
        {
          "block": 53,
          "time": "13:00",
          "schedule": 320,
          "actual": 281.1,
          "deviation": -38.9
        },
        {
          "block": 54,
          "time": "13:15",
          "schedule": 319,
          "actual": 279.5,
          "deviation": -39.5
        },
        {
          "block": 55,
          "time": "13:30",
          "schedule": 313,
          "actual": 272.9,
          "deviation": -40.1
        },
        {
          "block": 56,
          "time": "13:45",
          "schedule": 305,
          "actual": 263.8,
          "deviation": -41.2
        },
        {
          "block": 57,
          "time": "14:00",
          "schedule": 294,
          "actual": 251.2,
          "deviation": -42.8
        },
        {
          "block": 58,
          "time": "14:15",
          "schedule": 283,
          "actual": 238,
          "deviation": -45
        },
        {
          "block": 59,
          "time": "14:30",
          "schedule": 273,
          "actual": 225.4,
          "deviation": -47.6
        },
        {
          "block": 60,
          "time": "14:45",
          "schedule": 264,
          "actual": 213.5,
          "deviation": -50.5
        },
        {
          "block": 61,
          "time": "15:00",
          "schedule": 256,
          "actual": 202.8,
          "deviation": -53.2
        },
        {
          "block": 62,
          "time": "15:15",
          "schedule": 248,
          "actual": 192.7,
          "deviation": -55.3
        },
        {
          "block": 63,
          "time": "15:30",
          "schedule": 239,
          "actual": 182.4,
          "deviation": -56.6
        },
        {
          "block": 64,
          "time": "15:45",
          "schedule": 228,
          "actual": 171.2,
          "deviation": -56.8
        },
        {
          "block": 65,
          "time": "16:00",
          "schedule": 217,
          "actual": 161.1,
          "deviation": -55.9
        },
        {
          "block": 66,
          "time": "16:15",
          "schedule": 205,
          "actual": 151.1,
          "deviation": -53.9
        },
        {
          "block": 67,
          "time": "16:30",
          "schedule": 196,
          "actual": 145,
          "deviation": -51
        },
        {
          "block": 68,
          "time": "16:45",
          "schedule": 189,
          "actual": 141.3,
          "deviation": -47.7
        },
        {
          "block": 69,
          "time": "17:00",
          "schedule": 186,
          "actual": 141.7,
          "deviation": -44.3
        },
        {
          "block": 70,
          "time": "17:15",
          "schedule": 187,
          "actual": 145.8,
          "deviation": -41.2
        },
        {
          "block": 71,
          "time": "17:30",
          "schedule": 191,
          "actual": 152.4,
          "deviation": -38.6
        },
        {
          "block": 72,
          "time": "17:45",
          "schedule": 196,
          "actual": 159.3,
          "deviation": -36.7
        },
        {
          "block": 73,
          "time": "18:00",
          "schedule": 200,
          "actual": 164.5,
          "deviation": -35.5
        },
        {
          "block": 74,
          "time": "18:15",
          "schedule": 202,
          "actual": 167.2,
          "deviation": -34.8
        },
        {
          "block": 75,
          "time": "18:30",
          "schedule": 201,
          "actual": 166.7,
          "deviation": -34.3
        },
        {
          "block": 76,
          "time": "18:45",
          "schedule": 199,
          "actual": 165.3,
          "deviation": -33.7
        },
        {
          "block": 77,
          "time": "19:00",
          "schedule": 195,
          "actual": 162.2,
          "deviation": -32.8
        },
        {
          "block": 78,
          "time": "19:15",
          "schedule": 192,
          "actual": 160.6,
          "deviation": -31.4
        },
        {
          "block": 79,
          "time": "19:30",
          "schedule": 189,
          "actual": 159.5,
          "deviation": -29.5
        },
        {
          "block": 80,
          "time": "19:45",
          "schedule": 187,
          "actual": 159.9,
          "deviation": -27.1
        },
        {
          "block": 81,
          "time": "20:00",
          "schedule": 186,
          "actual": 161.4,
          "deviation": -24.6
        },
        {
          "block": 82,
          "time": "20:15",
          "schedule": 183,
          "actual": 160.7,
          "deviation": -22.3
        },
        {
          "block": 83,
          "time": "20:30",
          "schedule": 177,
          "actual": 156.5,
          "deviation": -20.5
        },
        {
          "block": 84,
          "time": "20:45",
          "schedule": 170,
          "actual": 150.4,
          "deviation": -19.6
        },
        {
          "block": 85,
          "time": "21:00",
          "schedule": 159,
          "actual": 139.3,
          "deviation": -19.7
        },
        {
          "block": 86,
          "time": "21:15",
          "schedule": 148,
          "actual": 127,
          "deviation": -21
        },
        {
          "block": 87,
          "time": "21:30",
          "schedule": 138,
          "actual": 114.6,
          "deviation": -23.4
        },
        {
          "block": 88,
          "time": "21:45",
          "schedule": 130,
          "actual": 103.5,
          "deviation": -26.5
        },
        {
          "block": 89,
          "time": "22:00",
          "schedule": 126,
          "actual": 95.9,
          "deviation": -30.1
        },
        {
          "block": 90,
          "time": "22:15",
          "schedule": 126,
          "actual": 92.3,
          "deviation": -33.7
        },
        {
          "block": 91,
          "time": "22:30",
          "schedule": 129,
          "actual": 92,
          "deviation": -37
        },
        {
          "block": 92,
          "time": "22:45",
          "schedule": 134,
          "actual": 94.3,
          "deviation": -39.7
        },
        {
          "block": 93,
          "time": "23:00",
          "schedule": 140,
          "actual": 98.4,
          "deviation": -41.6
        },
        {
          "block": 94,
          "time": "23:15",
          "schedule": 145,
          "actual": 102.2,
          "deviation": -42.8
        },
        {
          "block": 95,
          "time": "23:30",
          "schedule": 150,
          "actual": 106.5,
          "deviation": -43.5
        },
        {
          "block": 96,
          "time": "23:45",
          "schedule": 155,
          "actual": 111.1,
          "deviation": -43.9
        }
      ]
    },
    "revisionRows": [
      { "type": "Intra Day", "number": 6, "publishedAt": "14/05/2026 10:25", "scheduleMw": 335, "actualMw": 331.3, "deviationMw": -3.7, "dsmUpMw": 0, "dsmDownMw": 7 },
      { "type": "Day Ahead", "number": 3, "publishedAt": "13/05/2026 17:00", "scheduleMw": 330, "actualMw": 326, "deviationMw": -4, "dsmUpMw": 2.5, "dsmDownMw": 6.5 },
      { "type": "Week Ahead", "number": 2, "publishedAt": "10/05/2026 12:00", "scheduleMw": 325, "actualMw": 321, "deviationMw": -4, "dsmUpMw": 1.8, "dsmDownMw": 5.8 }
    ],
    "curtailment": { "totalEvents": 2, "totalMw": 50, "moderationEvents": 1, "moderationMw": 10, "activeEvents": 1, "activeMw": 20, "reliefMw": 45, "targetMw": 50, "lastId": "CURT-2026-05-14-001", "lastTime": "14/05/2026 09:45" },
    "curtailmentRecords": [
      { "id": "CURT-2026-05-14-001", "issued": "14/05/2026 09:45", "type": "Curtailment", "criteria": "Flow Area - 1, District - 1, Link - 1, Path - 1", "quantity": 50, "expected": 52.3, "achieved": 45, "status": "Active" },
      { "id": "CURT-2026-05-13-002", "issued": "13/05/2026 11:15", "type": "Curtailment", "criteria": "District - 1, Flow Area - 1,2", "quantity": 40, "expected": 41.2, "achieved": 40.1, "status": "Completed" },
      { "id": "MOD-2026-05-13-001", "issued": "13/05/2026 11:15", "type": "Moderation", "criteria": "Flow Area - 2", "quantity": 10, "expected": 10, "achieved": 9.8, "status": "Completed" }
    ]
  }]
}
